import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, H2, BODY } from "../shared";

const fragen = [
  "Wo genau finde ich diesen Job?",
  "Welche Qualifikationen brauche ich?",
  "Wie pimpe ich meine Bewerbungsunterlagen?",
];

export default function WirklichSection() {
  return (
    <Section testId="wirklich-section" className="py-24 md:py-36">
      <SectionLabel testId="wirklich-label">Die eine Sache</SectionLabel>
      <Reveal>
        <h2 className={`${H2} mb-12 max-w-3xl text-3xl md:text-5xl`}>Was willst Du wirklich, wirklich?</h2>
      </Reveal>
      <div className="max-w-3xl space-y-6">
        <Reveal delay={0.05}>
          <p className={BODY}>
            Du hast heute so viel mehr Möglichkeiten bei der Berufswahl als jemals zuvor in der Geschichte der Menschheit.
          </p>
        </Reveal>
        <Reveal delay={0.06}>
          <p className={BODY}>Gerade als Quereinsteigerin.</p>
        </Reveal>
        <Reveal delay={0.08}>
          <p className={BODY}>Die Wahrscheinlichkeit, dass da irgendwo Dein Traumjob dabei ist, ist seeeehr hoch.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className={BODY}>Die Wahrscheinlichkeit, dass Du einfach so darüber stolperst, ist allerdings seeeehr gering.</p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className={BODY}>Was Dir fehlt, ist nicht noch mehr Auswahl.</p>
        </Reveal>
        <Reveal delay={0.13}>
          <p className={BODY}>Sondern der ehrliche Blick auf Dich selbst.</p>
        </Reveal>
        <Reveal delay={0.14}>
          <p className={BODY}>Die EINE Sache, die Du für Deinen Traumjob brauchst, ist:</p>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="font-heading text-3xl font-700 uppercase tracking-tight text-cognac-2 md:text-5xl" style={{ fontWeight: 700 }}>
            KLARHEIT!
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p className={BODY}>Klarheit über Deine eigenen Stärken, Deine Bedürfnisse und Deine Wünsche.</p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className={BODY}>
            Denn: Du kannst nur nach etwas suchen, wenn Du weißt, wonach Du suchst. Und Du kannst nur nach etwas fragen, wenn Du weißt, wonach Du fragst.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <p className={BODY}>Alles andere –</p>
        </Reveal>
        <Reveal delay={0.23}>
          <ul className="space-y-2">
            {fragen.map((q) => (
              <li key={q} className="flex gap-3">
                <span className="mt-[0.85em] h-1.5 w-1.5 shrink-0 rounded-full bg-cognac-2" />
                <p className={BODY}>{q}</p>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.24}>
          <p className={BODY}>– kommt erst danach.</p>
        </Reveal>
        <Reveal delay={0.26}>
          <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>
            Allerdings kannst Du diese Klarheit nur außerhalb des alten Spielfeldes finden. Wenn Du Dir erlaubst, wirklich frei zu träumen.
          </p>
        </Reveal>
        <Reveal delay={0.28}>
          <p className="pt-2 font-heading text-2xl font-700 uppercase tracking-tight text-cognac-2 md:text-4xl" style={{ fontWeight: 700 }}>
            Unverschämt groß. Ohne Limits.
          </p>
        </Reveal>
      </div>
    </Section>
  );
}
